module.exports = __webpack_public_path__ + "static/media/xcp.37cecc8f.svg";